module.exports = __webpack_public_path__ + "static/media/img_join_process_mobile.5034e9eb.png";